import {
  DList,
  DListResponse,
  DObjectResponse,
  DResponse,
  TriggerTypes,
} from 'models/common.model';

export type MessageTemplateModel = {
  id: number;
  templateName: string;
  templateId: string;
  cost: number;
  urlPreviewImage: string;
  isActive?: boolean;
  messageType: number;
};

export enum ZNSTypes {
  RemindComeBack = 1,
  BirthDayMessage = 2,
  RemaindExchangePoint = 3,
  OtpMessage = 4,
}

export type GetMessageTemplateRequestModel = {
  id?: number;
};
export type GetMessageTemplateResponseModel = DResponse<
  DObjectResponse<MessageTemplateModel>
>;

export type ListMessageTemplateRequestModel = {
  pageIndex?: number;
  pageSize?: number;
  keyword?: string;
  messageType?: string;
  isActive?: boolean | null;
};

export type ListMessageTemplateResponseModel =
  DListResponse<MessageTemplateModel>;

export type SaveMessageTemplateRequestModel = {
  id?: number;
  templateName?: string;
  templateId?: string;
  cost?: string | null;
  isActive?: boolean | null;
  urlPreviewImage?: File | string | null;
  messageType?: number;
};
export type SaveMessageTemplateResponseModel = DObjectResponse<boolean>;

export type DeleteMessageTemplateRequestModel = {
  id?: number;
};
export type DeleteMessageTemplateResponseModel = DObjectResponse<boolean>;

export type InactiveMessageTemplateRequestModel = {
  id?: number;
};
export type InactiveMessageTemplateResponseModel = DObjectResponse<boolean>;

export type ActiveMessageTemplateRequestModel = {
  id?: number;
};
export type ActiveMessageTemplateResponseModel = DObjectResponse<boolean>;

export type SendMessageTemplateToMemberRequestModel = {
  customerIds?: Array<number | string>;
  isAll?: boolean;
  id: number;
  storeId?: number | null;
  toDaysFromLastTransaction?: number;
  fromDaysFromLastTransaction?: number;
};
export type SendMessageTemplateToMemberResponseModel = DObjectResponse<boolean>;

export interface MessageTemplateStateModel {
  messageTemplateListData: DList<MessageTemplateModel> | null;
  messageTemplateDetail: MessageTemplateModel | null;

  triggerSaveMessageTemplate: TriggerTypes | null;
  triggerSendMessageTemplateToMember: TriggerTypes | null;

  loadingList: boolean;
  loadingDetail: boolean;
  loadingSendMessageTemplateToMember: boolean;
}
